import { Injectable } from '@angular/core';
import { User } from '@tc-core/model/it/codegen/tbx/api/authority/v2/users/user';
import { MockAgentService } from '../services/mock-agent.service';
import { getCookie } from '../utils/browser.util';
import {CHAT_CONSTANTS} from '../utils/app.constants';

@Injectable({
  providedIn: 'root'
})
export class ChatAgentService {

  constructor(private mockAgentService: MockAgentService) {}

  async sendMessage(query: string, sessionId: string, user: User, useMockService = false): Promise<Response> {
    if (!user?.clientId) {
      throw new Error('Client ID not available');
    }

    if (useMockService) {
      return this.mockAgentService.fetch(CHAT_CONSTANTS.URLS.MOCK_AGENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
            auth_key: CHAT_CONSTANTS.AUTH.MOCK_KEY
        },
        body: JSON.stringify({ query, session_id: sessionId, client_id: user.clientId })
      });
    } else {
      return fetch(CHAT_CONSTANTS.URLS.AGENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth_key': getCookie('X-rst-session') || ''
        },
        body: JSON.stringify({ query, session_id: sessionId, client_id: user.clientId })
      });
    }
  }
}
